import React, { useContext } from "react";
import "../css/dashboard.css";
import AccountContent from "./AccountContent";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import NavbarV2 from "../component/NavbarV2";
import AccountContentV2Mobile from "./AccountContentV2Mobile";
import { LanguageContext } from "../context/LanguageContext";
import ProfileWidgetMobileNoRole from "../component/ProfileWidgetMobileNoRole";

export default function Account() {
  const { translate } = useContext(LanguageContext);
  const navigate = useNavigate();
  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });
  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div
            className="menu-button-container-mobile"
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              paddingRight: "0%",
            }}
          >
            <div
              style={{
                width: "30%",
                paddingLeft: "5%",
              }}
            >
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={handleMenuOpen}
                className="menu-button"
              >
                <MenuIcon />
              </IconButton>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "40%",
                alignItems: "center",
                alignContent: "center",
                alignSelf: "center",
                fontWeight: "700",
              }}
            >
              {translate("Profile")}
            </div>
            <div
              style={{
                width: "30%",
                paddingTop: "0px",
                paddingBottom: "0px",
                display: "flex",
                justifyContent: "end",
                alignContent: "center",
                alignItems: "center",
                alignSelf: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {/* <Tooltip
                  title={translate("ClickHereForHelp")}
                  placement="bottom"
                >
                  <HelpOutlineIcon
                    style={{
                      cursor: "pointer",
                      marginRight: "10px",
                      color: "#a9a9a9",
                    }}
                  />
                </Tooltip> */}
                {/* <Tooltip title={translate("Settings")} placement="bottom">
                  <SettingsIcon
                    onClick={handleSettings}
                    style={{
                      cursor: "pointer",
                      marginRight: "10px",
                      color: "#a9a9a9",
                    }}
                  />
                </Tooltip> */}
              </div>
              <ProfileWidgetMobileNoRole />
            </div>
          </div>

          <AccountContentV2Mobile />
        </>
      ) : (
        <>
          <NavbarV2 linkActive={14} />
          <AccountContent />
        </>
      )}
    </div>
  );
}
